export default __webpack_public_path__ + "static/media/S-029.59ffd5a8.png";